/*global require*/
// require in the complete CooWasm object and reassign it globally.
// This is meant for use with the Almond loader.
var CooWasm = require('./CooWasm')
if (typeof window !== 'undefined') {
    window.CooWasm = CooWasm
} else if (typeof self !== 'undefined') {
    self.CooWasm = CooWasm
} else if (typeof module !== 'undefined') {
    module.exports = CooWasm
} else {
    console.log('Unable to load CooWasm.')
}
